// locale-unextracted-ignore-file
import { DownloadMediaNotificationCompletedView } from '@app/modules/logger/screens/stream/features/download-media/NotificationViews';
import { useState } from 'react';
import { Id, toast } from 'react-toastify';

export interface CustomScreenDownloadMediaTabCompletedToastProps {
  toastId: Id;
}

/**
 * Toast body for CompletedView demo: holds downloading state and dismisses the toast on download.
 */
export function CustomScreenDownloadMediaTabCompletedToast({
  toastId,
}: CustomScreenDownloadMediaTabCompletedToastProps) {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = () => {
    setDownloading(true);
    setTimeout(() => {
      toast.dismiss(toastId);
      setDownloading(false);
    }, 1500);
  };

  return (
    <DownloadMediaNotificationCompletedView
      onDownload={handleDownload}
      downloading={downloading}
      fileSizeBytes={10004000}
    />
  );
}
